import { useMemo } from 'react'
import { includes } from 'lodash'

import { ROLES } from '../../common/constants'

import { useUserHasRoles } from '../../account/hooks'
import { MENU_CURATION_TASK_STATUS } from '../constants'

const useMenuCurationTaskAssignUserDisabledFlags = (
  menuCurationTask,
  isDisabled,
) => {
  const isUserScrapingReviewer = useUserHasRoles([ROLES.SCRAPING.value])

  const isUnknownWordsCurationAssignationDisabled = useMemo(() => {
    if (isUserScrapingReviewer) {
      return true
    }

    if (
      menuCurationTask.taskStatus ===
      MENU_CURATION_TASK_STATUS.UNKNOWN_WORDS_CURATION_IN_PROGRESS.value
    ) {
      return false
    }

    return (
      !menuCurationTask.isAvailableForUnknownWordsCuration ||
      !menuCurationTask.totalUnknownWordCount
    )
  }, [
    menuCurationTask.isAvailableForUnknownWordsCuration,
    menuCurationTask.taskStatus,
    menuCurationTask.totalUnknownWordCount,
    isUserScrapingReviewer,
  ])

  const isUnknownWordsQaAssignationDisabled = useMemo(() => {
    if (isUserScrapingReviewer) {
      return true
    }

    if (
      menuCurationTask.taskStatus ===
      MENU_CURATION_TASK_STATUS.UNKNOWN_WORDS_QA_IN_PROGRESS.value
    ) {
      return false
    }

    return (
      !menuCurationTask.isAvailableForUnknownWordsQa ||
      !menuCurationTask.totalUnknownWordCount
    )
  }, [
    isUserScrapingReviewer,
    menuCurationTask.isAvailableForUnknownWordsQa,
    menuCurationTask.taskStatus,
    menuCurationTask.totalUnknownWordCount,
  ])

  const isTierOneAssignationDisabled = useMemo(() => {
    if (isUserScrapingReviewer) {
      return true
    }

    if (
      menuCurationTask.taskStatus ===
      MENU_CURATION_TASK_STATUS.TIER_ONE_IN_PROGRESS.value
    ) {
      return false
    }

    return !menuCurationTask.isAvailableForTierOne
  }, [
    isUserScrapingReviewer,
    menuCurationTask.isAvailableForTierOne,
    menuCurationTask.taskStatus,
  ])

  const isCuratorAssignationDisabled = useMemo(() => {
    if (isUserScrapingReviewer) {
      return true
    }

    if (
      menuCurationTask.taskStatus ===
      MENU_CURATION_TASK_STATUS.CURATION_IN_PROGRESS.value
    ) {
      return false
    }

    return !menuCurationTask.isAvailableForCuration
  }, [
    isUserScrapingReviewer,
    menuCurationTask.isAvailableForCuration,
    menuCurationTask.taskStatus,
  ])

  const isQaAssignationDisabled = useMemo(() => {
    if (isUserScrapingReviewer) {
      return true
    }

    if (
      menuCurationTask.taskStatus ===
      MENU_CURATION_TASK_STATUS.QA_IN_PROGRESS.value
    ) {
      return false
    }

    return !menuCurationTask.isAvailableForQa
  }, [
    isUserScrapingReviewer,
    menuCurationTask.isAvailableForQa,
    menuCurationTask.taskStatus,
  ])

  const isQcAssignationDisabled = useMemo(() => {
    if (isUserScrapingReviewer) {
      return true
    }

    if (
      menuCurationTask.taskStatus ===
      MENU_CURATION_TASK_STATUS.QC_IN_PROGRESS.value
    ) {
      return false
    }

    return !menuCurationTask.isAvailableForQc
  }, [
    isUserScrapingReviewer,
    menuCurationTask.isAvailableForQc,
    menuCurationTask.taskStatus,
  ])

  const isScrapingReviewUserAssignationDisabled = useMemo(
    () =>
      !includes(
        [
          MENU_CURATION_TASK_STATUS.SCRAPING_REVIEW_IN_PROGRESS.value,
          MENU_CURATION_TASK_STATUS.AWAITING_SCRAPING_REVIEW.value,
        ],
        menuCurationTask.taskStatus,
      ),

    [menuCurationTask.taskStatus],
  )

  if (isDisabled) {
    return {
      isUnknownWordsCurationAssignationDisabled: true,
      isUnknownWordsQaAssignationDisabled: true,
      isTierOneAssignationDisabled: true,
      isCuratorAssignationDisabled: true,
      isQaAssignationDisabled: true,
      isQcAssignationDisabled: true,
      isScrapingReviewUserAssignationDisabled: true,
    }
  }

  return {
    isUnknownWordsCurationAssignationDisabled,
    isUnknownWordsQaAssignationDisabled,
    isTierOneAssignationDisabled,
    isCuratorAssignationDisabled,
    isQaAssignationDisabled,
    isQcAssignationDisabled,
    isScrapingReviewUserAssignationDisabled,
  }
}
export default useMenuCurationTaskAssignUserDisabledFlags
